module.exports = __webpack_public_path__ + "img/normal-marker.0dd2d3b6.svg";